import { useLocation } from "react-router-dom";
import ZetyAI from "./ZetyAI";

/**
 * Floating Techizen AI chat bubble on every public page (admin excluded).
 */
export default function ZetyChatFloat() {
  const { pathname } = useLocation();

  if (pathname.startsWith("/admin")) return null;

  return <ZetyAI variant="bubble" />;
}
